import React, {useRef, useState} from 'react'
import AutoForm from '@components/AutoForm'
import Button from '@components/Button'
import ErrorBox from '@components/ErrorBox'
import Checkbox from '@components/fields/Checkbox'
import ObjectField from '@components/fields/ObjectField'
import Phone from '@components/fields/Phone'
import DateText from '@packages/justo-parts/lib/components/fields/DateText'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'
import {Field} from 'simple-react-form'

import SpoonityTerms from './SpoonityTerms'

export default function Register({
  preferences,
  setRegisterSuccess,
  activeLoyalty,
  refetchPreferences
}) {
  const {user} = preferences
  const [modalOpen, setModalOpen] = useState<boolean>()
  const [termsType, setTermsType] = useState<string>()
  const [errors, setErrors] = useState<string>()
  const [signup, setSignup] = useState({
    name: 'spoonity',
    registration: {
      websiteId: preferences?.websiteId,
      firstName: user?.profile?.firstName ?? '',
      phone: user?.phone ?? '',
      lastName: user?.profile?.lastName ?? '',
      email: user?.email ?? '',
      birthday: null,
      password: '',
      privacyTerms: false,
      conditionTerms: false
    }
  })

  const {spoonitySignupSchema} = useQuery({
    query: gql`
      query spoonitySignupSchema {
        spoonitySignupSchema
      }
    `,
    variables: {}
  })

  const buttonRef = useRef()

  if (modalOpen) {
    return <SpoonityTerms close={() => setModalOpen(false)} termsType={termsType} />
  }

  const readyToSignup = signup?.registration.privacyTerms && signup?.registration.conditionTerms

  const activeLoyaltyLabel = activeLoyalty?.label ? activeLoyalty?.label : 'Programa de lealtad'
  return (
    <>
      <AutoForm
        mutation="loyaltySignup"
        doc={signup}
        onChange={values => {
          setSignup(values)
          if (errors) {
            setErrors(null)
          }
        }}
        buttonRef={buttonRef}
        onSuccess={() => {
          if (!user?.phone) refetchPreferences()
          setRegisterSuccess(true)
        }}
        onError={error => {
          setErrors(error?.message ?? 'Hubo un problema creando la cuenta')
        }}>
        <Field fieldName="registration" type={ObjectField}>
          <div className="grid grid-cols-2 gap-4">
            <Field fieldName="email" type={Text} label="Email" disabled={true} />
            <Field fieldName="phone" type={Phone} label="Teléfono" disabled={!!user?.phone} />
            <Field fieldName="firstName" type={Text} label="Nombre" />
            <Field fieldName="lastName" type={Text} label="Apellido" />
            <Field fieldName="password" type={Text} label="Contraseña" fieldType="password" />
            {!spoonitySignupSchema?.identificationId?.optional ? (
              <Field fieldName="identificationId" type={Text} label="Documento Identificación" />
            ) : null}
            <Field
              fieldName="birthday"
              type={DateText}
              label="Fecha de nacimiento"
              placeholder={'DD-MM-AAAA'}
            />
          </div>
          <div className="column">
            <div className="flex">
              <Field fieldName="conditionTerms" type={Checkbox} />
              <div
                className="pt-2 cursor-pointer"
                onClick={() => {
                  setTermsType('conditions')
                  setModalOpen(true)
                }}>
                He leído y aceptado los{' '}
                <strong>{`Términos y condiciones de uso de ${activeLoyaltyLabel}`}</strong>.
              </div>
            </div>
            <div className="flex">
              <Field fieldName="privacyTerms" type={Checkbox} />
              <div
                className="pt-2 cursor-pointer"
                onClick={() => {
                  setTermsType('privacy')
                  setModalOpen(true)
                }}>
                He leído y aceptado las{' '}
                <strong>{`Políticas de Privacidad de ${activeLoyaltyLabel}`}</strong>.
              </div>
            </div>
          </div>
        </Field>
      </AutoForm>

      <Button fullWidth primary ref={buttonRef} disabled={!readyToSignup}>
        Crear cuenta
      </Button>
      <br />
      {errors ? <ErrorBox message={errors} /> : null}
    </>
  )
}
